<div class="row" [formGroup]="form">
    <div class="col-md-12 mt-4">
        <hr/>
        <h5>Información sobre el Patrono</h5>
    </div>

    <div class="col-md-6" *ngFor="let field of formFields">
        <label class="form-labels mt-4">{{field.title}}</label>
        <div class="input-group">
            <input *ngIf="field.type != 'tel'" [type]="field.type" class="form-control" [formControlName]="field.formControlName">
            <input *ngIf="field.type == 'tel'" [type]="field.type" class="form-control" [formControlName]="field.formControlName" [brmasker]="{mask: '(000) 000-0000', type:'num'}" maxlength="14">
        </div>
    </div>

</div>